import React from 'react'
import FreightPlane from '../../images/freightplane.png'
import Medical from '../../images/medical.png'
import Quality from '../../images/quality.png'
import Warehouse from '../../images/warehouse.png'

class HomePage extends React.Component {
  render() {
    return (
      <div className="homepage-container">
        <div className="coverimage">
          <img src={Medical}></img>
        </div>
        <div className="aspect-row-container">
          <div className="aspect-container">
            <span className="title">
              QUALITY
            </span>
            <div className="icon-image">
              <img src={Quality}/>
            </div>
            <span className="aspect-description">
            PPE is an essential to the wellbeing of you and your family.  We are manufacturers and importers of PPE committed to delivering consistent products to the marketplace. In total our management team now boasts decades of specific industry experience that shows throughout our daily operation. All of our products are FDA approved so you can confidently keep you and your family safe.
            </span>
          </div>
          <div className="aspect-container">
            <span className="title">
              SHIPPING
            </span>
            <div className="icon-image">
              <img src={FreightPlane}/>
            </div>
            <span className="aspect-description">
            We ship from a convenient and strategic warehouse located in California. The growth we have experienced is a testament to our dedication to quality, competitiveness, on-time deliveries, and unmatched customer service. We take pride in servicing your needs; from the local business to the largest of chains you are assured the same attention to detail and commitment to your satisfaction.
            </span>
          </div>
        </div>

      </div>
    )
  }
}

export default HomePage